import { Component } from '@angular/core';
import { BeesFooterComponent } from '../bees-footer/bees-footer.component';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';

@Component({
  selector: 'app-pilotage-and-mooring',
  standalone: true,
  imports: [BeesFooterComponent, BeesHeaderComponent],
  templateUrl: './pilotage-and-mooring.component.html',
  styleUrl: './pilotage-and-mooring.component.scss'
})
export class PilotageAndMooringComponent {

}
